import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { verifyAndLoginAction } from '../../redux/actions/authAction';
import errorToast from '../../components/toast/errorToast';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../context/AuthContext';

const RedirectLogin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { fetchMe } = useAuth();
    const [loading, setloading] = useState(true);

    const onSuccess = async (data) => {
        await fetchMe();
        setloading(false);
        navigate('/over-view');
    };

    useEffect(() => {
        const token = localStorage.getItem('redirectToken');
        localStorage.removeItem('redirectToken');
        if (token) {
            setloading(true);
            dispatch(verifyAndLoginAction({ token }, onSuccess, (data) => {
                setloading(false);
                errorToast(data.data.message);
                localStorage.removeItem('isLoggedIn');
                sessionStorage.clear();
                navigate('/');
            }));
        }
    }, [])


    return (
        <div>{loading ? 'Verifying login and redirecting...' : 'Redirecting...'}</div>
    )
}

export default RedirectLogin